export function spaceBetween(
    ...arr: (string | undefined | null | false)[]
): string {
    return arr.filter(s => s).join(" ");
}
